import SceneController from 'controllers/sceneController';
import LawsDetailController
from 'controllers/settings/laws/lawsDetailController';
import LawsPlaceholderController from 'controllers/settings/laws/lawsPlaceholderController';
import * as _ from 'underscore'
import OverviewController from 'controllers/settings/entityOverviewController';

class LawsSceneController extends SceneController {
  show() {
    this.controller = new OverviewController({
      headerLocaleKey: 'webapp.settings.laws.header',
      entityType: 'law_entity',
      prefixSearchErrorLocaleKey: 'webapp.settings.laws.searchErrorNotification',
      knowledgebaseErrorLocaleKey: 'webapp.settings.laws.lawLoadErrorNotification'
    });
    this.showInLeftColumn(this.controller.view);
    this._showPlaceholder();
    this._registerListeners();
  }

  _showPlaceholder() {
    this._closeDetailView();
    this._showDetailController (LawsPlaceholderController, {});
  }

  _showDetailController(Controller, param) {
    this.detailController = new Controller(param);
    this.detailView = this.detailController.view;
    this.showInRightColumn(this.detailView);
  }

  _closeDetailView() {
    if (!_.isUndefined(this.detailView)) {
      this.detailView.close();
      delete this.detailView;
      this.detailController.close();
      delete this.detailController;
      this.focusRight();
    }
  }

  _registerListeners() {
    this.listenTo(this.controller, 'entity:clicked', this._showLawDetails);
    this.listenTo(this.controller, 'entity:closed', this._closeDetailView);
  }

  _showLawDetails(data) {
    this._showDetailController(
      LawsDetailController,
      { law: data }
    );

  }
}

export default LawsSceneController;
